import React from "react";
import FormField, { ControlSelect } from "./FormField";

// Styled native <select> — same look-and-feel as the text inputs.
// `options` = [{ value, label }]. `placeholder` is rendered as a disabled
// first option (empty value) for a "-- pilih --" affordance.
export default function SelectField({
  id,
  label,
  required,
  hint,
  error,
  value,
  onChange,
  options = [],
  placeholder,
}) {
  return (
    <FormField id={id} label={label} required={required} hint={hint} error={error}>
      <ControlSelect value={value ?? ""} onChange={onChange}>
        {placeholder && (
          <option value="" disabled>{placeholder}</option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </ControlSelect>
    </FormField>
  );
}
